import React from 'react';
import { useField, useFormikContext } from 'formik';
import { Input } from 'reactstrap';
import FieldWrapper from './FieldWrapper';

const FormikCheckbox = (props) => {
  const {
    name,
    label,
    title,
    className,
    fieldClassName,
    inputClassName = '',
    key,
    isGroup,
    ...restProps
  } = props;
  const [field, meta] = useField(name);
  const { value } = field || {};
  const { setFieldValue } = useFormikContext();

  const handleChange = (e) => {
    if (isGroup) {
      const itemValue = restProps?.value;
      let newValue = [];
      if (value?.includes(itemValue)) {
        newValue = (value || []).filter(i => i !== itemValue);
      } else {
        newValue = [...(value || []), itemValue]
      }
      setFieldValue(name, newValue);
    } else {
      setFieldValue(name, e?.target?.checked);
    }
  };

  return (
    <FieldWrapper
      name={name}
      label={title}
      fieldClassName={fieldClassName}
      className={className}
      key={key}
    >
      <div className={`form-check ${inputClassName}`}>
        <label className="form-check-label">
          <Input
            name={name}
            type="checkbox"
            invalid={meta?.touched && !!meta?.error}
            className="form-check-input"
            checked={isGroup ? value?.includes(restProps?.value) : !!value}
            onChange={handleChange}
            {...restProps}
          />
          {label}
        </label>
      </div>
    </FieldWrapper>
  );
};

export default FormikCheckbox;
